import { Radio, RadioChangeEvent, RadioGroupProps } from 'antd';

export type IRadioGroupProps = RadioGroupProps;
export type IRadioChangeEvent = RadioChangeEvent;

export default Radio.Group;
